import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past ~600px (roughly past the hero)
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-13">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-0 left-0 right-0 z-50 md:bottom-6 md:left-auto md:right-6 md:w-auto" data-id="element-14">
          {/* Mobile: full-width bar */}
          <div className="bg-white/95 backdrop-blur-md border-t border-gold/20 px-4 py-3 md:border md:rounded-xl md:shadow-lg md:shadow-charcoal/10 md:border-t-0" data-id="element-15">
            <div className="flex items-center justify-between gap-4 max-w-prose mx-auto md:max-w-none" data-id="element-16">
              <div className="hidden md:block" data-id="element-17">
                <p className="font-sans text-sm font-semibold text-charcoal" data-id="element-18">
                  Anti-Hinchazón 14 Días
                </p>
                <p className="font-sans text-xs text-charcoal/50" data-id="element-19">
                  Precio de lanzamiento: US$11.99
                </p>
              </div>
              <a href="https://tiendadigitaljj.com//cart/43446651256910:1" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-center gap-2 w-full md:w-auto bg-terracotta hover:bg-terracotta-dark text-white font-sans font-semibold text-sm md:text-base py-3 px-6 rounded-lg transition-colors duration-200" data-id="element-20">
                <span className="md:hidden" data-id="element-21">
                  Descarga 14 días Anti-Hinchazón — US$11.99
                </span>
                <span className="hidden md:inline" data-id="element-22">
                  Descarga 14 días Anti-Hinchazón
                </span>
                <ArrowRightIcon className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" data-id="element-23" />
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}